<template>
    <v-container class="grey-lighten-3 full-height">

        <!-- Printable Area -->
        <v-row justify="center">
            <v-col cols="12" xl="10" lg="11" md="12">
                <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

                    <!-- Watermark -->
                    <div class="watermark">
                        <img v-if="purchaseOrderData?.branch?.company?.watermark && invoiceHeader" :src="getFileServerUrl + purchaseOrderData?.branch?.company?.watermark" alt="">
                    </div>

                    <div class="invoice-container">
                        <div class="invoice-content">
                            <table style="width: 100%; border-collapse: collapse;">
                                <thead>
                                    <tr v-if="purchaseOrderData?.branch?.company?.header_image && invoiceHeader">
                                        <td colspan="100%">
                                            <img :src="`${getFileServerUrl}${purchaseOrderData?.branch?.company?.header_image}`" style="width: 100%;" alt="">
                                        </td>
                                    </tr>
                                </thead>

                                <tbody>
                                    <!-- Header Section -->
                                    <tr v-if="!purchaseOrderData?.branch?.company?.header_image && invoiceHeader">
                                        <td colspan="100%">
                                            <div class="page-header">
                                                <div class="header-section d-flex justify-space-between align-start">
                                                    <div class="company-info">
                                                        <h4 class="company-name">{{ purchaseOrderData?.branch?.company?.name || 'Company Name Not Available' }}</h4>
                                                        <p class="company-text">{{ purchaseOrderData?.branch?.company?.address || '-' }}</p>
                                                        <p class="company-text">
                                                            <v-icon size="small">mdi-phone-outline</v-icon>
                                                            {{ purchaseOrderData?.branch?.company?.mobile || '-' }}
                                                        </p>
                                                        <p class="company-text">
                                                            <v-icon size="small">mdi-email-outline</v-icon>
                                                            {{ purchaseOrderData?.branch?.company?.email || '-' }}
                                                        </p>
                                                        <p class="company-text" v-if="purchaseOrderData?.branch?.company?.website">
                                                            <v-icon size="small">mdi-web</v-icon>
                                                            {{ purchaseOrderData?.branch?.company?.website }}
                                                        </p>
                                                    </div>

                                                    <div class="logo-container">
                                                        <v-img
                                                            :src="`${getFileServerUrl.replace(/\/$/, '')}/${purchaseOrderData?.branch?.company?.logo || 'uploads/demo_images/user.png'}`"
                                                            max-width="150"
                                                            max-height="70"
                                                            contain
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- Title -->
                                    <tr>
                                        <td colspan="100%">
                                            <div class="text-center my-6">
                                                <h2 class="report-title">PURCHASE ORDER</h2>
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- Main Content -->
                                    <tr>
                                        <td colspan="100%" class="page-content-cell details-table">
                                            <div class="page-content" style="font-size: 12px;">
                                                <!-- Master Information -->
                                                <div class="meta-info-box mb-0">
                                                    <div class="d-flex">
                                                        <div class="meta-item d-flex align-center"
                                                            style="width: 50%;">
                                                            <span class="meta-label">Purchase Order No:</span>
                                                            <span class="meta-value pl-2">{{ purchaseOrderData?.code }}
                                                                {{
                                                                  purchaseOrderData?.purchase_type == 1
                                                                    ? '(Local)'
                                                                    : purchaseOrderData?.purchase_type == 2
                                                                    ? '(Import)'
                                                                    : ''
                                                                }}
                                                              </span>
                                                        </div>
                                                        <div class="meta-item d-flex align-center justify-end"
                                                            style="width: 50%;">
                                                            <!-- <span class="meta-label pl-2"> Date:</span>
                                                            <span class="meta-value pl-2">{{ formatDateView(purchaseOrderData?.purchase_date)
                                                                }}</span> -->
                                                        </div>
                                                    </div>
                                                    <div class="d-flex">
                                                        <div style="width: 100%; height: auto; min-height: auto;">
                                                          <div style="display: flex; justify-content: space-between;">
                                                            <div>
                                                              <div style="margin-bottom: 8px;">
                                                                  <strong>To,</strong>
                                                              </div>
                                                              <div style="margin-bottom: 4px; font-weight: bold;">
                                                                  {{ purchaseOrderData?.supplier?.supplier_name || '-' }}
                                                              </div>
                                                              <div style="margin-bottom: 16px;">
                                                                  {{ purchaseOrderData?.supplier?.supplier_address || '-' }}
                                                              </div>
                                                            </div>

                                                            <div>
                                                              <div class="meta-item d-flex align-center"
                                                                  >
                                                                  <span class="meta-label">Purchase Order No:</span>
                                                                  <span class="meta-value pl-2">{{ purchaseOrderData?.code }}</span>
                                                              </div>
                                                              <div class="meta-item d-flex align-center justify-end"
                                                                  >
                                                                  <span class="meta-label pl-2"> Date:</span>
                                                                  <span class="meta-value pl-2">{{ formatDateView(purchaseOrderData?.purchase_date)
                                                                      }}</span>
                                                              </div>
                                                            </div>
                                                          </div>
                                                            <div style="margin-bottom: 4px;" v-if="purchaseOrderData?.subject">
                                                                <strong>Subject: {{ purchaseOrderData.subject }}</strong>
                                                            </div>
                                                            <div style="margin-bottom: 4px;" v-else>
                                                                <strong>Subject: Purchase Order for {{ purchaseOrderData?.code }}</strong>
                                                            </div>
                                                            <div style="margin-bottom: 4px;">
                                                                Dear Sir,
                                                            </div>
                                                            <div style="margin-bottom: 0;">
                                                                We are pleased to place work order with the following item as per terms and condition.
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Purchase Requisition Details Table -->
                                                <div class="table-container mb-6 mt-0">
                                                    <table class="dep-table details-table mt-5" style="width: 100%; border-collapse: collapse;">
                                                        <thead>
                                                            <tr>
                                                                <th class="text-center" style="width: 40px; border: 1px solid #000; padding: 2px; font-size: 12px;">SL</th>
                                                                <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Product Name</th>
                                                                <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Product Code</th>
                                                                <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Unit</th>
                                                                <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Quantity</th>
                                                                <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Free Quantity</th>
                                                                <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Price</th>
                                                                <th style="border: 1px solid #000; padding: 2px; font-size: 12px;">Amount</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            <tr v-for="(detail, index) in DetailsData"
                                                                :key="detail.id">
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: center; font-size: 12px;">{{ index + 1 }}</td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: center; font-size: 12px;">{{ detail.product?.name }}</td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: center; font-size: 12px;">{{ detail.product?.code }}</td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: center; font-size: 12px;">{{ detail.product?.unit?.name }}</td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-size: 12px;">{{ detail?.qty }}</td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-size: 12px;">{{ detail?.free_qty }}</td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-size: 12px;"><v-icon size="small">{{ getCurrencyIcon(purchaseOrderData?.purchase_type) }}</v-icon>{{ formatNumber(detail?.rate) }}</td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-size: 12px;"><v-icon size="small">{{ getCurrencyIcon(purchaseOrderData?.purchase_type) }}</v-icon>{{ formatNumber(detail?.qty * detail?.rate) }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px; font-weight: bold;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">Subtotal</td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;"><v-icon size="small">{{ getCurrencyIcon(purchaseOrderData?.purchase_type) }}</v-icon>{{ formatNumber(purchaseOrderData?.sub_total) }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">Discount</td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;"><v-icon size="small">{{ getCurrencyIcon(purchaseOrderData?.purchase_type) }}</v-icon>{{ formatNumber(purchaseOrderData?.discount_amount) }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">Tax
                                                                  ({{
                                                                    purchaseOrderData?.tax_type === "1"
                                                                    ? "Included"
                                                                    :purchaseOrderData?.tax_type === "2"
                                                                    ? "Excluded"
                                                                    : "Exempted"
                                                                  }})
                                                                </td>
                                                                
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;"><v-icon size="small">{{ getCurrencyIcon(purchaseOrderData?.purchase_type) }}</v-icon>{{ formatNumber(purchaseOrderData?.tax_amount) }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">Vat
                                                                  ({{
                                                                    purchaseOrderData?.vat_type === "1"
                                                                    ? "Included"
                                                                    :purchaseOrderData?.vat_type === "2"
                                                                    ? "Excluded"
                                                                    : "Exempted"
                                                                  }})
                                                                </td>
                                                                
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;"><v-icon size="small">{{ getCurrencyIcon(purchaseOrderData?.purchase_type) }}</v-icon>{{ formatNumber(purchaseOrderData?.vat_amount) }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">Grand Total</td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;"><v-icon size="small">{{ getCurrencyIcon(purchaseOrderData?.purchase_type) }}</v-icon>{{ formatNumber(purchaseOrderData?.grand_total) }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; font-size: 12px;"></td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;">Advance payment</td>
                                                                <td style="border: 1px solid #000; padding: 2px; text-align: right; font-weight: bold; font-size: 12px;"><v-icon size="small">{{ getCurrencyIcon(purchaseOrderData?.purchase_type) }}</v-icon>{{ purchaseOrderData?.paid }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <!-- Grand Total in Words -->
                                                <div class="amount-in-words-section mb-4" v-if="purchaseOrderData?.grand_total" style="font-size: 12px;">
                                                    <div class="font-weight-bold">
                                                        Amount in Words: <span style="font-weight: normal; text-transform: capitalize;">{{ getGrandTotalInWords() }}</span>
                                                    </div>
                                                </div>

                                                <div v-if="purchaseOrderData?.payment_bank" style="font-size: 12px; margin: 15px 0px; background-color: #ffffff;">
                                                  <p><strong>Wire Transfer to following bank account: </strong></p>
                                                  <table style="border-collapse: collapse;">
                                                    <tbody >
                                                      <tr>
                                                        <td style="border:none; width: 200px;">Account Name</td>
                                                        <td style="border:none;">:{{  purchaseOrderData?.payment_bank?.account_name? `${purchaseOrderData?.payment_bank?.account_name}`: ""  }}</td>
                                                      </tr>
                                                      <tr>
                                                        <td style="border:none;">Account Number</td>
                                                        <td style="border:none;">:{{ purchaseOrderData?.payment_bank?.account_no? `${purchaseOrderData?.payment_bank?.account_no}`: ""  }}</td>
                                                      </tr>
                                                      <tr>
                                                        <td style="border:none;">Name of the Bank</td>
                                                        <td style="border:none;">:{{ purchaseOrderData?.payment_bank?.name? `${purchaseOrderData?.payment_bank?.name}`: ""  }}</td>
                                                      </tr>
                                                      <tr>
                                                        <td style="border:none;">Branch Name</td>
                                                        <td style="border:none;">:{{ purchaseOrderData?.payment_bank?.branch? `${purchaseOrderData?.payment_bank?.branch}`: ""  }}</td>
                                                      </tr>
                                                      <tr>
                                                        <td style="border:none;">Swift Code</td>
                                                        <td style="border:none;">:{{ purchaseOrderData?.payment_bank?.swift_code? `${purchaseOrderData?.payment_bank?.swift_code}`: ""  }}</td>
                                                      </tr>
                                                      <tr>
                                                        <td style="border:none;">Routing No.</td>
                                                        <td style="border:none;">:{{ purchaseOrderData?.payment_bank?.routing_no? `${purchaseOrderData?.payment_bank?.routing_no}`: ""  }}</td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </div>

                                                <!-- Terms and Conditions Section -->
                                                <div class="terms-section mb-4 page-break" v-if="purchaseOrderData?.terms_and_condition">
                                                    <div class="font-weight-bold mb-2">
                                                        Terms and Conditions:
                                                    </div>
                                                    <div class="terms-content" style="color: #000; line-height: 1.4; white-space: pre-wrap;">
                                                        {{ purchaseOrderData.terms_and_condition }}
                                                    </div>
                                                </div>

                                                <!-- Prepared By Info -->
                                                <div class="d-flex mb-4 page-break" style="justify-content: space-between; font-size: 12px;">
                                                    <div class="prepared-section" style="width: 50%;">
                                                        <div class="font-weight-bold mb-1">Prepared By:</div>
                                                        <div>{{ purchaseOrderData?.created_by?.full_name || '-' }}</div>
                                                        <div v-if="purchaseOrderData?.created_by?.branch?.company?.name">
                                                            {{ purchaseOrderData?.created_by?.branch?.company?.name }}
                                                        </div>
                                                    </div>
                                                    <div class="prepared-section" style="width: 30%;">
                                                        <div class="font-weight-bold mb-1 pr-2">Approved By:</div>
                                                        <div class="pr-2">{{ purchaseOrderData?.approval_current_process?.employee?.name || '-' }}</div>
                                                        <div class="pr-2" v-if="purchaseOrderData?.approval_current_process?.employee?.name">
                                                            {{ purchaseOrderData?.approval_current_process?.employee?.branch?.company?.name }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <tfoot>
                                    <tr>
                                        <td colspan="100%" style="border:none">
                                            <div style="width:100%;height: 100px;">&nbsp;</div>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>

                        <div class="invoice-footer">
                            <img v-if="purchaseOrderData?.branch?.company?.footer_image && invoiceHeader" :src="`${getFileServerUrl}${purchaseOrderData?.branch?.company?.footer_image}`" alt="" style="width: 100%; display: block;">
                        </div>
                    </div>

                </v-sheet>
            </v-col>
        </v-row>

        <!-- Print Button -->
        <v-row justify="end" class="d-print-none mt-4 ">
            <v-col cols="12"  justify="center" style="display:flex; justify-content: center;">
                <v-btn color="primary" prepend-icon="mdi-printer" @click="print(0)">
                    Print without pad
                </v-btn>
                <v-btn color="primary" prepend-icon="mdi-printer" class="ml-2" @click="print(1)">
                    Print with pad
                </v-btn>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import html2pdf from "html2pdf.js";
import convertNumberToWords from "@/plugins/numberToWord";
import { formatDateView, formatDateDash } from "@/plugins/helpers";

export default {
    name: "purchaseOrderInvoice",

    data() {
        return {
            mainId: null,
            purchaseOrderData: null,
            DetailsData: null,
            invoiceHeader: true,
            pagePadding: 0,
            types: [
              { id: 1, name: "Normal" },
              { id: 2, name: "Urgent" },
            ],
        };
    },

    computed: {
        getFileServerUrl() {
            return this.$store.getters.getFileServerUrl;
        },
    },

    methods: {
        formatDateView,
        getCurrencyIcon(type) {
          return type == 2 ? 'mdi-currency-usd' : 'mdi-currency-bdt'
        },
        formatNumber(num) {
            if (num == null || num === "") return "";
            return Number(num).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },
        getGrandTotalInWords() {
            if (!this.purchaseOrderData?.grand_total) {
                return "Zero Taka Only";
            }
            try {
                return convertNumberToWords(this.purchaseOrderData.grand_total);
            } catch (error) {
                console.error('Error converting number to words:', error);
                return "Zero Taka Only";
            }
        },
        async downloadPDF() {
            const element = document.getElementById("printable-area");
            const opt = {
                margin: [0.5, 0.5],
                filename: `purchase-order-${this.purchaseOrderData?.code}.pdf`,
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: { 
                    scale: 2, 
                    useCORS: true,
                    backgroundColor: '#ffffff',
                    logging: false,
                    letterRendering: true
                },
                jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
            };
            await html2pdf().set(opt).from(element).save();
        },
        print(isPad) {
            if (isPad === 1) {
                this.invoiceHeader = true;
                this.pagePadding = 0;
            } else if (isPad === 0) {
                this.invoiceHeader = false;
                this.pagePadding = 100;
            }

            setTimeout(() => {
                const printContent = document.getElementById("printable-area").innerHTML;
                const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);
            
                printWindow.document.write(`
                  <!DOCTYPE html>
                  <html>
                  <head>
                  <meta charset="UTF-8">
                  <meta name="viewport" content="width=device-width, initial-scale=1.0">
                  <title>Purchase Order</title>
                  <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
                  <style>
                    * {
                      margin: 0;
                      padding: 0;
                      box-sizing: border-box;
                    }
            
                    @page {
                      size: A4;
                      margin: ${this.pagePadding}px 0;
                    }
            
                    html, body {
                      margin: 0 ;
                      padding: 0; 
                      width: 100%;
                      height: auto;
                    }
            
                    body { 
                      font-family: sans-serif; 
                      background:#fff; 
                      color:#000; 
                      -webkit-print-color-adjust: exact; 
                      print-color-adjust: exact;
                      margin: 0;
                      padding: 0;
                    }
            
                    .report-paper { 
                      width: 100%; 
                      padding: 0 !important;
                      background: #fff;
                      margin: 0;
                    }

                    .page-break {
                        page-break-inside: avoid;
                    }
                    .font-weight-bold {
                        font-weight: bold;
                    }
            
                    .invoice-container {
                      width: 100%;
                      margin: 0;
                      padding: 0;
                    }
            
                    .invoice-content {
                      width: 100%;
                      margin: 0;
                      padding: 0;
                      overflow: visible;
                    }
            
                    header img {
                      width: 100%;
                      display: block;
                      margin: 0;
                      padding: 0;
                    }
            
                    table {
                      width: 100%;
                      margin: 0;
                      padding: 0;
                    }

                    .details-table {
                      padding: 0px 32px;
                    }
            
                    footer {
                      position: fixed;
                      bottom: 0;
                      left: 0;
                      right: 0;
                      width: 100%;
                      z-index: 10;
                      -webkit-print-color-adjust: exact;
                      print-color-adjust: exact;
                    }
            
                    footer img {
                      width: 100%;
                      display: block;
                      margin: 0;
                      padding: 0;
                    }
            
                    .header-section { 
                      display: flex; 
                      justify-content: space-between; 
                      align-items: flex-start; 
                      border-bottom: 2px solid #eee; 
                      padding-bottom: 10px; 
                      margin-bottom: 16px; 
                    }
            
                    .company-name { 
                      font-size: 12px; 
                      font-weight: bold; 
                      text-transform: uppercase; 
                      margin: 0 0 4px 0; 
                    }
            
                    .company-text { 
                      font-size: 12px; 
                      margin: 2px 0; 
                      display: flex; 
                      align-items: center; 
                    }
            
                    .logo-container img { 
                      max-height: 70px; 
                      max-width: 150px; 
                    }
            
                    .report-title { 
                      font-size: 16px; 
                      text-align: center; 
                      padding: 5px 0; 
                    }
            
                    .watermark {
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      z-index: 0;
                    }
            
                    table { 
                      width: 100% !important; 
                      border-collapse: collapse; 
                      font-size: 12px; 
                      margin: 8px 0;
                      background: white;
                      -webkit-print-color-adjust: exact;
                      print-color-adjust: exact;
                    }
            
                    th, td { 
                      border: none; 
                      padding: 0; 
                      vertical-align: middle; 
                    }
            
                    th { 
                      background: #e0e0e0; 
                      text-align: center; 
                      font-weight: bold;
                      -webkit-print-color-adjust: exact;
                      print-color-adjust: exact;
                    }
            
                    .text-center { text-align: center; }
                    .text-right { text-align: right; }
                    .text-left { text-align: left; }
                    
                    table {
                      page-break-inside: avoid;
                      orphans: 3;
                      widows: 3;
                    }

                    .mt-4 { 
                      margin-top: 0px !important;
                      margin-left: -10px !important;
                      margin-right: -10px !important;
                    }
                    .mt-5 { 
                      margin-top: 5px !important;
                      margin-left: 0px !important;
                      margin-right: 0px !important;
                    }
                    .mt-8 { margin-top: 0px !important; }
                    .my-6 { margin-top: 0px !important; margin-bottom: 0px !important; }
            
                    img { 
                      max-width: 100% !important; 
                      height: auto !important; 
                    }
            
                    .d-flex { display: flex; }
                    .justify-space-between { justify-content: space-between; }
                    .align-start { align-items: flex-start; }
                    .v-row { 
                      display: flex !important; 
                      flex-wrap: wrap !important; 
                      margin: 0;
                      width: 100%;
                      padding: 0px 30px;
                      justify-content:space-between;
                    }
            
                    .v-col-6 { 
                      flex: 0 0 50% !important; 
                      max-width: 50% !important; 
                      padding: 0 12px 12px 12px;
                      box-sizing: border-box;
                      margin: 0;
                    }
            
                    .pa-6 { padding: 0 !important; }
            
                    /* Prevent sections from breaking across pages */
                    div[style*="margin-top"], div[style*="padding"] {
                      page-break-inside: avoid;
                    }
            
                    .order-table tbody tr {
                      page-break-inside: avoid;
                    }
            
                    .signature-box {
                      font-size: 12px;
                      border: 1px solid black;
                      border-radius: 5px;
                      padding: 10px;
                    }
            
                    .signature-line {
                      border-bottom: 1px solid #000;
                      margin: 50px 0;
                      height: 30px;
                    }
            
                    .signature-label {
                      text-transform: uppercase;
                      font-weight: bold;
                      font-size: 12px;
                    }
            
                    .invoice-container {
                      display: flex;
                      flex-direction: column;
                    }
            
                    .invoice-content {
                      flex: 1;
                      overflow: visible;
                      margin-top: -10px;
                    }
                      
                    .company-info {
                      flex: 1;
                    }
            
                    .invoice-footer {
                      margin-top: auto;
                      position: fixed;
                      left; 0;
                      bottom: 0;
                      width: 100%;    
                    }
            
                    @media print { 
                      body {
                        margin: 0;
                        padding: 0;
                      }
            
                      .report-paper {
                        margin: 0;
                        padding: 0;
                      }
            
                      main {
                        padding-top: 180px;
                        padding-bottom: 150px;
                        padding-left: 20px;
                        padding-right: 20px;
                      }
            
                      .watermark {
                        position: fixed;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        z-index: 0;
                      }
                        
                      .order-table {
                        page-break-inside: auto;
                      }
            
                      .order-table tr {
                        page-break-inside: avoid;
                        page-break-after: auto;
                      }
            
                      .order-table thead {
                        display: table-header-group;
                      }
                    }
                  </style>
                  </head>
                  <body>
                    ${printContent}
                  </body>
                  </html>
                `);
            
                printWindow.document.close();
                printWindow.focus();
                setTimeout(() => {
                  printWindow.print();
                }, 500);
                this.invoiceHeader = true;
                this.pagePadding = 0;
            }, 500);
        },
    },
    mounted() {
        const id = this.$route.query.id;
        this.mainId = id;
        this.DetailsData = null;
        this.$store.dispatch("getPurOrderById", id).then((response) => {
            this.purchaseOrderData = response;
            this.DetailsData = response.purOrderDetails || response.pur_order_details || [];
        }).catch((error) => {
            console.error('Error fetching purchase order:', error);
        });
    }
};
</script>

<style scoped>
.full-height { min-height: 60vh; }
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background: white; }
.company-name { font-size: 12px; font-weight: bold; text-transform: uppercase; }
.company-text { font-size: 12px; }
.report-title { font-size: 16px; text-align: center; margin: 5px 0; }
.meta-box { border: 1px solid #000; padding: 2px; font-size: 12px; margin-bottom: 16px; }
.dep-table { width: 100%; border-collapse: collapse; font-size: 12px; }
.dep-table th, .dep-table td { border: 1px solid #000; padding: 2px; font-size: 12px; }
.dep-table th { background: #e0e0e0; }
.text-center { text-align: center; }
.text-right { text-align: right; }
.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}

.d-print-none {
  display: block !important;
}

.invoice-container {
  width: 100%;
  margin: 0;
  padding: 0;
}

.invoice-content {
  width: 100%;
  margin: 0;
  padding: 0;
}

.invoice-footer {
  width: 100%;
}


.header-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 16px;
}

.company-info {
  flex: 1;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.logo-container img {
  max-height: 70px;
  max-width: 150px;
}

.page-content {
  display: block;
}

.page-content-cell {
  padding: 0 !important;
  border: none !important;
}

.my-6 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.d-flex {
  display: flex;
}

.justify-space-between {
  justify-content: space-between;
}

.align-start {
  align-items: flex-start;
}

.align-center {
  align-items: center;
}

.justify-end {
  justify-content: flex-end;
}

.font-weight-bold {
  font-weight: bold;
}

.pl-2 {
  padding-left: 8px;
}

.mb-0 {
  margin-bottom: 0;
}

.mb-4 {
  margin-bottom: 16px;
}

.mb-6 {
  margin-bottom: 24px;
}

.mt-0 {
  margin-top: 0;
}

.mt-5 {
  margin-top: 5px;
}

.ml-2 {
  margin-left: 8px;
}

.gap-2 {
  gap: 8px;
}

.details-table {
  padding: 0px 32px;
}

.table-container {
  margin-bottom: 24px;
}

.meta-info-box {
  border: none;
  margin-bottom: 16px;
  font-size: 12px;
}

.meta-item {
  height: auto;
  display: flex;
  align-items: center;
}

.meta-label {
  font-weight: 500;
  color: #000;
  padding-left: 0;
  text-align: left;
}

.meta-value {
  padding-left: 8px;
  color: #000;
}

.amount-in-words-section {
  margin-bottom: 16px;
  color: #000;
  text-align: left;
}

.terms-section {
  margin-bottom: 16px;
  color: #000;
}

.terms-content {
  color: #000;
  line-height: 1.4;
  white-space: pre-wrap;
}

.prepared-section {
  margin-bottom: 16px;
  color: #000;
}

.system-generated-footer {
  text-align: center;
  margin-top: 20px;
  padding-top: 10px;
  font-size: 8px;
  color: #666;
  border-top: 1px solid #ddd;
}

@media print {
  .d-print-none {
    display: none !important;
  }
}
</style>